import React, { useState, useEffect, useRef } from "react";
import { fetchLogoOnce } from "../utils/logoService";
import { useLocation } from "react-router-dom";

export default function DownloadNotice() {
  const location = useLocation();
  const barRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [logoUrl, setLogoUrl] = useState("/logo.png");
  const [selectedBrand, setSelectedBrand] = useState("default");

  // ── Brand detection ─────────────────────────────────────────
  useEffect(() => {
    const hostname = window.location.hostname.toLowerCase();
    const origin = window.location.origin;
    let brand = "default";

    if (hostname.includes("beetbuzz")) brand = "beetbuzz";
    else if (hostname.includes("localhost")) brand = "localhost";
    else if (hostname.includes("7xplay")) brand = "7xplay";
    else if (hostname.includes("bk8bd") || hostname.includes("cb444")) brand = "bk8bd";
    else {
      // derive from origin: strip protocol, www, and TLD
      brand = origin
        .replace(/^https?:\/\/(www\.)?/, "")
        .replace(/(\.com|\.live|\.net|\.world|\.bet|\.buzz|\.win|\.pro)$/i, "");
    }

    const envBrand = process.env.REACT_APP_BRAND;
    if (envBrand) brand = envBrand;

    const stored = localStorage.getItem("brand");
    if (stored) brand = stored;

    setSelectedBrand(brand);
    localStorage.setItem("brand", brand);
  }, []);

  // ── Logo fetch ───────────────────────────────────────────────
  useEffect(() => {
    fetchLogoOnce().then((item) => {
      if (!item) return;
      const path =
        item.mobile_logo || item.logo || item.loader_logo;
      if (path) {
        const clean = path.replace(/^\/storage\//, "");
        setLogoUrl(`${process.env.REACT_APP_API_URL}/storage/${clean}`);
      }
    }).catch(() => {});
  }, []);

  // ── Show/hide bar ────────────────────────────────────────────
  useEffect(() => {
    if (location.pathname !== "/") { setVisible(false); return; }
    const hidden = sessionStorage.getItem("barHidden") === "true";
    if (!hidden) setVisible(true);
  }, [location.pathname]);

  // ── Push page content down by bar height ─────────────────────
  useEffect(() => {
    const root = document.getElementById("root");
    if (!root) return;
    if (visible && barRef.current) {
      root.style.setProperty(
        "--download-bar-height",
        `${barRef.current.offsetHeight}px`
      );
      root.classList.add("download-bar-open");
    } else {
      root.style.setProperty("--download-bar-height", "0px");
      root.classList.remove("download-bar-open");
    }
  }, [visible]);

  // ── APK resolution ───────────────────────────────────────────
  const triggerDownload = (url, filename) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const tryDownloadApk = () => {
    fetchLogoOnce().then((item) => {
      // Primary: URL set in admin panel
      const apiUrl =
        item?.app_download || item?.android_app ||
        item?.apk_url || item?.download_url || item?.apk;
      if (apiUrl) {
        const full = apiUrl.startsWith("http")
          ? apiUrl
          : `${process.env.REACT_APP_API_URL}/storage/${apiUrl}`;
        triggerDownload(full, "app.apk");
        return;
      }
      // Fallback: hostname-derived path
      const hostname = window.location.hostname.replace(/^www\./, "");
      const name = hostname.replace(
        /\.(com|live|net|world|bet|buzz|win|pro|top|site|xyz)$/i, ""
      );
      triggerDownload(
        `${window.location.origin}/app/${name}.apk`,
        `${name}.apk`
      );
    }).catch(() => {
      const hostname = window.location.hostname.replace(/^www\./, "");
      const name = hostname.replace(
        /\.(com|live|net|world|bet|buzz|win|pro|top|site|xyz)$/i, ""
      );
      triggerDownload(
        `${window.location.origin}/app/${name}.apk`,
        `${name}.apk`
      );
    });
  };

  const handleClose = (e) => {
    e.stopPropagation();
    sessionStorage.setItem("barHidden", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div ref={barRef} className={`download-bar ${visible ? "show-bar" : ""}`}>
      <div className="download-bar-icon">
        <img src={logoUrl} alt="App" />
      </div>
      <div className="download-bar-info">
        <span className="download-bar-name">Download App</span>
        <span className="download-bar-sub">Fast &amp; Secure</span>
      </div>
      <button className="download-bar-btn" onClick={tryDownloadApk}>
        Download
      </button>
      <button className="download-bar-close" onClick={handleClose}>
        ✕
      </button>
    </div>
  );
}
